export default __webpack_public_path__ + "../staticImages/logo_hawesko.svg";